<template>
  <div class="equalizer" :class="{ 'equalizer--animated': animation }">
    <span class="equalizer__bar"></span>
    <span class="equalizer__bar"></span>
    <span class="equalizer__bar"></span>
    <span class="equalizer__bar"></span>
    <span class="equalizer__bar"></span>
    <span class="equalizer__bar"></span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    animation: {
      type: Boolean,
      default: false,
    },
  },
})
class ComponentName extends Vue {
  animation!: boolean;
}

export default ComponentName;
</script>

<style lang="scss" scoped>
.equalizer {
  display: flex;
  align-items: flex-end;
  gap: 2px;

  width: 36px;
  height: 22px;

  &__bar {
    width: 4px;
    height: 100%;
    flex-shrink: 0;

    background: linear-gradient(180deg, #ffdc82 0%, #e5ad46 55%, #aa7625 100%);

    transform-origin: bottom;

    // Анимация включается только через prop
    .equalizer--animated & {
      animation: equalizer-bar 0.8s ease-in-out infinite alternate;
    }

    &:nth-child(1) {
      --min-height: 0.35;
      --max-height: 0.65;

      transform: scaleY(0.5);
      animation-delay: -0.7s;
    }

    &:nth-child(2) {
      --min-height: 0.55;
      --max-height: 1;

      transform: scaleY(0.9);
      animation-delay: -0.2s;
    }

    &:nth-child(3) {
      --min-height: 0.3;
      --max-height: 0.8;

      transform: scaleY(0.75);
      animation-delay: -0.5s;
    }

    &:nth-child(4) {
      --min-height: 0.45;
      --max-height: 0.7;

      transform: scaleY(0.55);
      animation-delay: -0.1s;
    }

    &:nth-child(5) {
      --min-height: 0.35;
      --max-height: 0.9;

      transform: scaleY(0.8);
      animation-delay: -0.6s;
    }

    &:nth-child(6) {
      --min-height: 0.25;
      --max-height: 0.55;

      transform: scaleY(0.35);
      animation-delay: -0.3s;
    }
  }
}

@keyframes equalizer-bar {
  from {
    transform: scaleY(var(--min-height));
  }

  to {
    transform: scaleY(var(--max-height));
  }
}
</style>
